export const NOTIFICATIONS = "v2/notifications";
export const MARK_AS_READ = "v2/notifications/mark-as-read";
export const SAVE_TOKEN = "v2/notifications/save-token";